
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/linear/notification","xmlns":"http://www.w3.org/2000/svg","width":"34","height":"34","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 133124","fill":"#4c535f"}},[_c('path',{attrs:{"d":"M17.031 3.4a9.325 9.325 0 016.467 2.564 8.526 8.526 0 012.703 6.211v3.866a5.6 5.6 0 00.674 2.361l1.611 2.548a3.311 3.311 0 01.313 2.926 3.462 3.462 0 01-2.238 2.109 31.418 31.418 0 01-9.541 1.479 31.422 31.422 0 01-9.543-1.48 3.535 3.535 0 01-2.313-2.1 3.308 3.308 0 01.391-2.934l1.615-2.555a5.422 5.422 0 00.684-2.355v-3.865A8.991 8.991 0 0117.031 3.4zm-.007 22.564a29.924 29.924 0 009.088-1.409 1.974 1.974 0 001.283-1.2 1.821 1.821 0 00-.174-1.608L25.6 19.181a7.057 7.057 0 01-.895-3.144v-3.862A7.491 7.491 0 0017.031 4.9a7.491 7.491 0 00-7.677 7.275v3.866a6.9 6.9 0 01-.914 3.153L6.823 21.75a1.843 1.843 0 00-.248 1.625 2.026 2.026 0 001.36 1.18 29.92 29.92 0 009.085 1.409z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M19.696 5.317a.749.749 0 01-.209-.03 7.922 7.922 0 00-1.266-.264 9.817 9.817 0 00-1.214-.073 8.73 8.73 0 00-2.438.341.75.75 0 01-.763-.214.75.75 0 01-.146-.783A3.593 3.593 0 0117.028 2a3.593 3.593 0 013.366 2.294.75.75 0 01-.7 1.024zM17.028 31.165a5.111 5.111 0 01-3.588-1.489 5.111 5.111 0 01-1.489-3.588h1.5a3.6 3.6 0 001.05 2.527 3.6 3.6 0 002.527 1.05 3.581 3.581 0 003.573-3.577h1.5a5.082 5.082 0 01-5.073 5.077z"}})])])
          )
        }
      }
    